module.exports = __webpack_public_path__ + "img/accept.68a33019.svg";